import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { EntitlementStatus } from './types';

/**
 * Fetches the deployment's enforcement/entitlement status (GET /api/v1/entitlement/status). The endpoint
 * is auth-protected but never itself entitlement-gated, so a denying deployment can always report why.
 * A bounded refetch keeps the banner current as the clock-evaluated state transitions (grace → restricted
 * → locked) without a bespoke poller.
 */
export function useEntitlementStatus() {
  return useQuery<EntitlementStatus>({
    queryKey: ['entitlement-status'],
    queryFn: () => api.get<EntitlementStatus>('/entitlement/status'),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
